<template>
  <header-block name="Home"></header-block>
  <aside-block active="home" />
  <div class="container mt-3">
    <div class="p-4 row">
      <div class="col-9">
        <div class="dashboard-cards my-4 d-flex flex-wrap gap-3">
          <router-link
              to="/editor"
              class="card overview-card text-decoration-none"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-files"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M15 3v4a1 1 0 0 0 1 1h4" />
              <path
                  d="M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z"
              />
              <path
                  d="M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
              />
            </svg>
            <div class="card-text">Pages</div>
            <div class="card-count">{{page_count}}</div>
          </router-link>
          <router-link to="/menu" class="card overview-card text-decoration-none">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-category"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M4 4h6v6h-6z" />
              <path d="M14 4h6v6h-6z" />
              <path d="M4 14h6v6h-6z" />
              <path d="M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            </svg>
            <div class="card-text">Menus</div>
            <div class="card-count">{{menu_count}}</div>
          </router-link>
          <router-link
              to="/translate"
              class="card overview-card text-decoration-none"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-transaction-yen"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M15 16h6" />
              <path d="M15 12l3 4.5" />
              <path d="M21 12l-3 4.5v4.5" />
              <path d="M15 19h6" />
              <path d="M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
              <path d="M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
              <path d="M7 5h8" />
              <path d="M7 5v8a3 3 0 0 0 3 3h1" />
            </svg>
            <div class="card-text">Translations</div>
            <div class="card-count"></div>
          </router-link>
        </div>

        <TemplateSelector v-bind:sites="webshops" :templates="templates" />


        <!-- search engines -->
        <div class="search-stats my-4">
          <h4 class="mb-3">Search engines</h4>
          <div
              v-if="searchDataAvailable"
              class="search-data d-flex flex-wrap gap-3"
          >
            <div class="d-flex justify-content-center gap-2">
              <button
                  v-if="!connected.google"
                  class="btn btn-primary"
                  @click="login('Google')"
              >
                Google login
              </button>
              <button
                  v-if="!connected.microsoft"
                  class="btn btn-outline-primary"
                  @click="login('Microsoft')"
              >
                Microsoft login
              </button>
            </div>
            <div class="card search-list-card">
              <div class="card-title">Top pages</div>
              <ul>
                <li
                    v-for="item in topPagesList"
                    :key="item.page"
                    class="search-list-item"
                >
                  <span class="item-name">{{ item.page }}</span>
                  <span class="item-value" v-if="item.value">{{
                      item.value
                    }}</span>
                </li>
              </ul>
            </div>
            <div class="card search-list-card">
              <div class="card-title">Devices</div>
              <ul>
                <li v-for="item in devicesList" :key="item.device">
                  {{ item.device }}
                  <span class="badge bg-info ms-2">{{ item.value }}</span>
                </li>
              </ul>
            </div>
            <div class="card search-list-card">
              <div class="card-title">Countries</div>
              <ul>
                <li v-for="item in countriesList" :key="item.country">
                  {{ item.country }}
                  <span class="badge bg-info ms-2">{{ item.value }}</span>
                </li>
              </ul>
            </div>
            <div class="card search-list-card">
              <div class="card-title">Most popular search terms</div>
              <ul>
                <li v-for="item in topQueriesList" :key="item.query">
                  {{ item.query }}
                  <span class="badge bg-info ms-2">{{ item.value }}</span>
                  <i :class="getSearchIcon(item.source)" class="ms-1"></i>
                </li>
              </ul>
            </div>
          </div>
          <div v-else class="empty-state text-center p-4">
            <i class="bi bi-search display-4 mb-2"></i>
            <div class="mb-2">
              Log in to your search accounts to view statistics.
            </div>
            <div class="d-flex justify-content-center gap-2">
              <button
                  v-if="!connected.google"
                  class="btn btn-primary"
                  @click="login('Google')"
              >
                Google login
              </button>
              <button
                  v-if="!connected.microsoft"
                  class="btn btn-outline-primary"
                  @click="login('Microsoft')"
              >
                Microsoft login
              </button>
            </div>
            <small class="text-muted d-block mt-2">
              Statistics help you optimize your website's SEO and traffic.
            </small>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="recent-activity">
          <h4 class="mb-3">Recent activities</h4>
          <div class="timeline">
            <div
                v-for="item in recentActivities"
                :key="item.id"
                class="timeline-item"
            >
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-name">{{ item.first_name }} {{ item.last_name }}</div>
                <div class="timeline-type">{{ item.name }}</div>
                <small class="timeline-date">{{ item.date }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderBlock from "../components/header";
import AsideBlock from "../components/asideBlock";
import TemplateSelector from "../components/TemplateSelector.vue";
import http from "../modules/http";
export default {
  name: "HomePage",
  components: { TemplateSelector, AsideBlock, HeaderBlock },
  data() {
    return {
      webshops: [],
      templates: [],
      recentActivities: [],
      searchDataAvailable: false,
      connected: {
        google: false,
        microsoft: false,
      },
      topPagesList: [
        {
          page: "Home",
          value: 123,
        },
      ],
      devicesList: [],
      countriesList: [],
      topQueriesList: [],
      menu_count: null,
      page_count: null,
    };
  },
  mounted() {
    http.fetch(`/themes`).then((data) => {
      this.webshops = data.webshops;
      this.templates = data.data;
      this.page_count = data.page_count;
      this.menu_count = data.menu_count;
      this.recentActivities = data.history;
    });
  },
  methods: {
    login(service = null) {
      http
          .fetch(`/service-integrations/login/${service}`)
          .then((data) => {
            location.href = data.redirect;
          });
    },
  },
};
</script>
<style scoped>
.dashboard-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.overview-card {
  flex: 1 1 180px;
  height: 120px;
  background: #f8f9fa;
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #000;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}
.overview-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.card-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}
.card-count {
  font-size: 1.5rem;
  margin-top: 0.25rem;
  color: #713AE8;
}
.timeline {
  border-left: 2px solid #dee2e6;
  margin-left: 1rem;
  padding-left: 1rem;
}
.timeline-item {
  position: relative;
  margin-bottom: 1rem;
}
.timeline-dot {
  position: absolute;
  left: -8px;
  top: 4px;
  width: 12px;
  height: 12px;
  background: #0056ab;
  border-radius: 50%;
}
.timeline-content {
  margin-left: 1rem;
}
.timeline-type {
  font-weight: 600;
  color: #333;
}
.timeline-name {
  color: #555;
}
.timeline-date {
  color: #888;
  font-size: 0.8rem;
}
.card-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.stat-value {
  font-weight: 500;
}
.empty-state {
  color: #555;
  background: #f8f9fa;
  border-radius: 0.75rem;
}
.empty-state i {
  color: #0056ab;
}

.search-data {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.search-list-card {
  flex: 1 1 220px;
  background: #ffffff;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}
.card-title {
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #333;
  font-size: 1rem;
}
.search-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0;
  border-bottom: 1px solid #eee;
  font-size: 0.9rem;
}
.search-list-item:last-child {
  border-bottom: none;
}
.item-name {
  color: #555;
  font-weight: 500;
}
.item-value {
  font-weight: 600;
  color: #007bff;
  margin-left: auto;
}
.search-icon {
  font-size: 1rem;
  color: #888;
}
</style>
